import { json2csv } from 'json-2-csv';

export interface CsvExportOptions {
  filename?: string;
  keys?: string[];
}

/**
 * Export data array to CSV file
 * @param data - Array of objects to export
 * @param options - Export options (filename and optional keys for column order)
 * @returns Promise with success status and row count
 */
export async function exportDataToCSV(
  data: any[],
  options: CsvExportOptions = {}
): Promise<{ success: boolean; rowCount: number }> {
  try {
    if (data.length === 0) {
      throw new Error('No data to export');
    }

    // If keys are not provided, use the keys from the first object
    const keys = options.keys || Object.keys(data[0]);

    const csvOptions = {
      keys,
      emptyFieldValue: '',
      expandNestedObjects: false,
      useDateIso8601Format: true,
    };
    
    const csv = await json2csv(data, csvOptions);
    
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    
    const defaultFilename = `data-export-${new Date().toISOString().split('T')[0]}.csv`;
    const filename = options.filename || defaultFilename;
    
    link.href = url;
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    setTimeout(() => URL.revokeObjectURL(url), 100);
    
    return { success: true, rowCount: data.length };
  } catch (error) {
    console.error('CSV export failed:', error);
    throw error;
  }
}
